export const obavijest_sudu_o_dost_novom= {
    templateId: 72.1,
    category: 7,
    templateTitle: 'Ovrha - obavijest sudu o izvršenoj dostavi rješenja o ovrsi novom poslodavcu, uslijed prestanku radnog odnosa radnika protiv kojega postoji rješenje o ovrsi',
    templateDescription: `<p>Poslodavac koji je zaprimio rješenje o ovrsi protiv radnika, dužan je kod prestanka radnog odnosa, rješenje o ovrsi dostaviti novom poslodavcu (u slučaju da mu je poznat) te o tome obavijestiti i sud.</p>`,
  
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Kod prestanka radnog odnosa radnika za kojega je zaprimio rješenja o ovrsi, poslodavac ima sljedeće obveze:</p>
    <li> ukoliko mu je poznat novi poslodavac - bez odgode preporučenom pošiljkom s povratnicom dostaviti rješenje o ovrsi novom poslodavcu prema primjeru <a class="local-link" href="/contract?template=71">ovdje</a> i o tome obavijestiti sud prema dolje navedenom primjeru, </li>
    <li> ukoliko mu nije poznat novi poslodavac - bez odgode obavijestiti sud o prestanku ugovora o radu prema primjeru <a class="local-link" href="/contract?template=72">ovdje</a>, o čemu će sud obavijestiti ovrhovoditelja, određujući mu rok radi pribave podataka o novom poslodavcu.</li>
    <br>Poslodavac koji je propustio postupiti prema navedenim obvezama,  odgovara za štetu koju je ovrhovoditelj zbog toga pretrpio.</br>
    <br>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Povrat osnove za plaćanje radniku (dužniku), slanje osnove za plaćanje krivom adresatu/primatelju ili nepostupanje prema obvezama iz Ovršnog zakona</strong></p>
    <p>Pojašnjenje:  postoji opasnost za poslodavca da će odgovarati za štetu vjerovniku ukoliko ispravu preda trećemu (radniku ili bilo kojoj drugoj osobi) ili ne postupi kako je zakonom određeno. Iz navedenih razloga, uvijek je potrebno postupiti kako je gore navedeno.</p>

    <h5>PRAVNA OSNOVA</h5>
    <p>Ovršni zakon.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Naziv suda",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
    ],
      suffix: "",
    }
  ],

  headline: "",

    
    title: '\r\n\r\nPREDMET: Obavijest sudu o izvršenoj dostavi rješenja o ovrsi novom poslodavcu',
    noArticleNumbers: true,
    noArticleTitle: true,

    articles: [
     
        {
            title: "",
            mandatory: true,
            dummy: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  { type: "text", content: "Na poslovni broj:OVR-" },
                  { type: "input", value: "", required: true, help: "Potrebno je upisati broj predmeta u kojemu je doneseno rješenje o ovrsi - broj predmeta ima naznaku OVR."},
                ],
              }
            ]
          },

                {
                    title: '',
                    mandatory: true,
                    exampleContent: true,
                    dummy: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Poštovani,\r\n\r\novim putem Vas obavještavamo da je radniku ______________, iz _________________, prestao radni odnos kod nas te smo u tom smislu postupili sukladno čl. 200. Ovršnog zakona na način da smo dostavili rješenje o ovrsi novom poslodavcu ___________________, iz __________________ .  \r\n\r\nS poštovanjem.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Sudu \r\n2) Kadrovska služba \r\n',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/72.1_obavijest_sudu_o_dost_novom.ts